import { maskDecimal } from '@givebutter/util';
import * as NodeBadges from 'assets/js/pages/engage/workflows/components/NodeBadges';
import { transformOperatorToReadable } from 'components/filter/filters-next/readable';
import { CurrencySymbol } from 'customHooks/useCurrencySymbol';
import { capitalize } from 'lodash';

interface AmountBadgesProps {
    amount: string;
    amountEnd: string;
    operator: 'bet' | 'lt' | 'gt' | 'eq';
}
const AmountBadges = ({ amount, amountEnd, operator }: AmountBadgesProps) => {
    return (
        <>
            <NodeBadges.NodeBadgeSeparator>AND</NodeBadges.NodeBadgeSeparator>
            <NodeBadges.Badge>
                <span className="text-gray-900">
                    {capitalize(transformOperatorToReadable(operator))}
                </span>{' '}
                {operator === 'bet' ? (
                    <>
                        <span className="text-gray-900">
                            <CurrencySymbol />
                            {maskDecimal(amount)}
                        </span>{' '}
                        and{' '}
                        <span className="text-gray-900">
                            <CurrencySymbol />
                            {maskDecimal(amountEnd)}
                        </span>
                    </>
                ) : (
                    <span className="text-gray-900">
                        <CurrencySymbol />
                        {maskDecimal(amount)}
                    </span>
                )}
            </NodeBadges.Badge>
        </>
    );
};

export { AmountBadges };
